import { AxiosRequestConfig } from 'axios'
import { secondsToMilliseconds } from 'date-fns'
import { useEffect, useState } from 'react'
import { HttpMethod } from '../../constants/httpMethod'
import { useAuth } from '../useAuth'

enum Header {
  AUTHORIZATION = 'authorization',
  CONTENT_TYPE = 'Content-Type',
}

enum ContentType {
  JSON = 'application/json',
}

type HttpClientConfig = Record<string, any>

interface UseHttpClientContext {
  config?: HttpClientConfig
  isLoading: boolean
}

const MAX_TIMEOUT_IN_SECONDS = 60

const defaults: Partial<AxiosRequestConfig> = {
  headers: {
    [Header.CONTENT_TYPE]: ContentType.JSON,
  },
  method: HttpMethod.GET,
  timeout: secondsToMilliseconds(MAX_TIMEOUT_IN_SECONDS),
}

const useHttpClientConfig = (): UseHttpClientContext => {
  const [config, setConfig] = useState<HttpClientConfig>()
  const { accessToken } = useAuth()

  useEffect(() => {
    if (!accessToken) return

    let headers = { ...defaults.headers }

    if (accessToken) {
      headers = {
        ...headers,
        [Header.AUTHORIZATION]: `Bearer ${accessToken}`,
      }
    }

    const config = {
      ...defaults,
      headers,
    }

    setConfig(config)
  }, [accessToken])

  return {
    config,
    isLoading: Boolean(accessToken),
  }
}

export type { HttpClientConfig }
export { useHttpClientConfig }
